import React from 'react';
import PropTypes from 'prop-types';
import { path } from 'ramda';
import { injectIntl, intlShape } from 'react-intl';

import { getLatestCommitData } from 'lib/documentHandling';

import InfoFI from './InfoFI';
import InfoEN from './InfoEN';
import InfoSV from './InfoSV';
import printElem from 'lib/printElement';

const FSMCInfoText = ({ document, statusDoc = {}, intl: { locale, formatMessage } }) => {
  const totalScore = (path(['scores', 'mental'], document) || 0) + (path(['scores', 'physical'], document) || 0);
  const statusMood =
    path(['commits', 'length'], statusDoc) > 0
      ? path(['sections', 'narcomsDepression'], getLatestCommitData(statusDoc))
      : 0;

  return (
    <div id="fsmcInfoArea">
      {locale === 'en' ? (
        <InfoEN totalScore={totalScore} statusMood={statusMood} document={document} />
      ) : locale === 'sv' ? (
        <InfoSV totalScore={totalScore} statusMood={statusMood} document={document} />
      ) : (
        <InfoFI totalScore={totalScore} statusMood={statusMood} document={document} />
      )}
      <a href="#" onClick={() => printElem('fsmcInfoArea', 'MyMS - FSMC')}>
        {formatMessage({ id: 'dictionary.print' })}
      </a>
    </div>
  );
};

FSMCInfoText.propTypes = {
  document: PropTypes.object,
  statusDoc: PropTypes.object,
  intl: intlShape
};

export default injectIntl(FSMCInfoText);
